// extracted by mini-css-extract-plugin
export var errorIcon = "_o6-1";
export var nameLogo = "_o6-0";